import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import { UiModule } from '@app/ui';

@Component({
  selector: 'sbnb-add-task-rule-flow-access',
  standalone: true,
  imports: [MatLegacyRadioModule, UiModule, FormsModule],
  templateUrl: './add-task-rule-flow-access.component.html',
})
export class AddTaskRuleFlowAccessComponent {
  // Inputs from parent
  createOperationCodes = input<boolean | null>(null);
  note = input<string>('');
  hasSmartlocks = input<boolean>(false);

  // Outputs to parent
  createOperationCodesChanged = output<boolean>();
  noteChanged = output<string>();

  updateTaskPropertyAccess(value: boolean) {
    this.createOperationCodesChanged.emit(value);
  }

  updateTaskNote(value: string) {
    this.noteChanged.emit(value);
  }
}
